import http from './../../lib/http';
import api from './../../lib/api';

export const SMS_RULES_LIST                 = 'SMS_RULES_LIST';

export const SMS_RULES_LOAD                 = 'SMS_RULES_LOAD';
export const SMS_RULES_UPDATE               = 'SMS_RULES_UPDATE';
export const SMS_RULES_CREATE               = 'SMS_RULES_CREATE';

export const SMS_RULES_LOAD_DATATABLE       = 'SMS_RULES_LOAD_DATATABLE';

export const SMS_RULES_CHANGE               = 'SMS_RULES_CHANGE';
const SMS_RULES_LOADING_CHANGE              = 'SMS_RULES_LOADING_CHANGE';
const SMS_RULES_SAVING_CHANGE               = 'SMS_RULES_SAVING_CHANGE';
const SMS_RULES_ERRORS_CHANGE               = 'SMS_RULES_ERRORS_CHANGE';

const SMS_RULES_CREATING_CHANGE             = 'SMS_RULES_CREATING_CHANGE';

const SMS_RULES_DATATABLE_CHANGE            = 'SMS_RULES_DATATABLE_CHANGE';
const SMS_RULES_DATATABLE_LOADING_CHANGE    = 'SMS_RULES_DATATABLE_LOADING_CHANGE';

export const SMS_RULES_DELETE		      = 'SMS_RULES_DELETE';
export const SMS_RULES_DELETE_CHANGE        = 'SMS_RULES_DELETE_CHANGE';

const state = {
    sms_rules            : [],
    sms_provider         : null,

    sms_rules_loading    : false,
    sms_rules_saving     : false,
    sms_rules_errors     : {},

    sms_rules_list_total     : 0, 
    sms_rules_total          : 0,
    sms_rules_list           : null,
    sms_rules_list_loading   : false,

    sms_rules_creating           : false,
    sms_rules_creating_errors    : {},
    sms_rules_empty              : {
                                  id: 0,
                                  name: "",
                                  code: ""
                              }
};

const actions = {
    [SMS_RULES_LOAD] ({ commit, state }, id) {

        if(!id) {
	    state.sms_rules_empty = {id:0, name: null, sms_rules:null, data:[]};
            commit(SMS_RULES_CHANGE, state.sms_rules_empty);

            return;
        }   
        state.sms_provider = id;    
        return api.load('sms_rules', id, state, commit, SMS_RULES_LOADING_CHANGE, SMS_RULES_CHANGE);
    },

    [SMS_RULES_UPDATE] ({ commit, state }, data) {
        let id      = data.id;
        let model   = data.model;        
        return api.update('sms_rules', id, model, state, commit, SMS_RULES_SAVING_CHANGE, SMS_RULES_CHANGE, SMS_RULES_ERRORS_CHANGE);
    },

    [SMS_RULES_CREATE] ({ commit, state }, data) {
        let model   = data.model;
        let id      = data.id ? data.id : 0;


        return api.create('sms_rules.list', id, model, state, commit, SMS_RULES_CREATING_CHANGE, SMS_RULES_CHANGE, SMS_RULES_ERRORS_CHANGE);
    },

    [SMS_RULES_LOAD_DATATABLE] ({ commit, state }, id) {

        if(!id) {
            id  = 0;
        }

        return api.list(
            'sms_rules.list', 
            id, 
            null,
            state, 
            commit, 
            SMS_RULES_DATATABLE_LOADING_CHANGE, 
            SMS_RULES_DATATABLE_CHANGE);
    },
    [SMS_RULES_DELETE] ({ commit, state }, id) {
        if(!id) {
            id  = 0;
        }

        return api.delete(
            'sms_rules',
            id,
            state,
            commit,
            SMS_RULES_DELETE_CHANGE
        );
    },


};

const mutations = {
    [SMS_RULES_DATATABLE_LOADING_CHANGE](state, data) {
        state.sms_rules_list_loading = data;
    },
    [SMS_RULES_DATATABLE_CHANGE](state, data) {

        if(data) {
            state.sms_rules_list        = data.data;
            state.sms_rules_list_total  = data.total;
        }
        else {
            state.sms_rules_list        = [];
            state.sms_rules_list_total  = 0;
        }        
    },
    [SMS_RULES_CHANGE](state, data) {        
        if(data) {
            state.sms_rules        = data.data;  
            state.sms_rules_errors       = {};   
        }
        else {
            state.sms_rules        = [];            
            state.sms_rules_errors       = {};
        }                
    },
    [SMS_RULES_LOADING_CHANGE](state, data) {
        state.sms_rules_loading = data;
    },
    [SMS_RULES_SAVING_CHANGE](state, data) {
        state.sms_rules_saving   = data;
    },
    [SMS_RULES_ERRORS_CHANGE](state, data) {                
        state.sms_rules_errors   = data;
    },
    [SMS_RULES_CREATING_CHANGE](state, data) {
        state.sms_rules_creating = data;
    },
    [SMS_RULES_DELETE_CHANGE](state, id) {

        if (id) {
            if (state.sms_rules) {

                let list = [];
                state.sms_rules.forEach(sms_rules => {
                    if (sms_rules.id !== id) {
                        list.push({...sms_rules});
                    }
                });

                state.sms_rules = list;
            }
        }
    },


};

export default {
    state,
    actions,
    mutations
}
